import type { DrawerProps, ModalProps } from "antd";
import { useIsMobile } from "../useIsMobile";

const CSS = `
.ap-full-modal{overflow:hidden}
.ap-full-modal .ant-modal{top:0!important;margin:0!important;padding:0!important;max-width:100vw!important;width:100vw!important}
.ap-full-modal .ant-modal-content{border-radius:0;min-height:100dvh;display:flex;flex-direction:column;padding:0}
.ap-full-modal .ant-modal-header{padding:14px 52px 14px 16px;margin:0;border-bottom:1px solid #E2DED3}
.ap-full-modal .ant-modal-body{flex:1;overflow-y:auto;overflow-x:hidden;padding:16px}
.ap-full-modal .ant-modal-footer{margin:0;padding:10px 16px calc(10px + env(safe-area-inset-bottom));border-top:1px solid #E2DED3;display:grid;grid-template-columns:1fr 1fr;gap:10px}
.ap-full-modal .ant-modal-footer .ant-btn{height:48px;font-size:16px;margin:0!important}
.ap-full-modal .ant-modal-footer .ant-btn:only-child{grid-column:1/-1}
.ap-full-modal .ant-modal-close{top:10px}
.ap-full-modal input,.ap-full-modal textarea,.ap-full-modal .ant-select-selector{font-size:16px!important}
.ap-full-drawer .ant-drawer-footer{padding:10px 12px calc(10px + env(safe-area-inset-bottom))}
.ap-full-drawer .ant-drawer-footer .ant-btn{height:48px;font-size:16px}
.ap-full-drawer .ant-drawer-body{overflow-x:hidden}
.ap-full-drawer input,.ap-full-drawer textarea{font-size:16px!important}
.ap-full-drawer .ant-descriptions-item-label{width:38%}
.ap-big-slider{padding:6px 10px}
@media (max-width:767px){.ap-big-slider{padding:14px 12px}.ap-big-slider .ant-slider-rail,.ap-big-slider .ant-slider-track{height:10px;border-radius:5px}.ap-big-slider .ant-slider-handle{inset-block-start:2px}.ap-big-slider .ant-slider-handle::before,.ap-big-slider .ant-slider-handle::after{width:28px;height:28px;inset-inline-start:-8px;inset-block-start:-8px;border-radius:50%}}
.ap-m-table .ant-table-container{overflow-x:auto}
`;
if (typeof document !== "undefined" && !document.getElementById("ap-mobile-css")) {
  const st = document.createElement("style");
  st.id = "ap-mobile-css";
  st.textContent = CSS;
  document.head.appendChild(st);
}

/** Props da spalmare su <Modal>: a schermo intero su smartphone, invariata su desktop. */
export function useFullModal(desktopWidth?: number | string): Partial<ModalProps> {
  const mobile = useIsMobile();
  if (!mobile) return desktopWidth ? { width: desktopWidth } : {};
  return { width: "100%", wrapClassName: "ap-full-modal", centered: false };
}

/** Drawer: a tutto schermo dal basso su smartphone, largo `w` su desktop. */
export function useFullDrawer(w: number): Partial<DrawerProps> {
  const mobile = useIsMobile();
  if (!mobile) return { width: w };
  return { placement: "bottom", height: "100%", rootClassName: "ap-full-drawer", styles: { body: { padding: 12 }, header: { padding: "12px 14px" } } };
}
